import { createAction, props } from '@ngrx/store';
import { TeamInfo } from 'src/app/recruiting/candidates/new-profile/team-info/models/team-info.model';

export const loadTeamInfo = createAction('[TEAM INFO COMPONENT] Load Team Info', props<{ candidateId: number }>());
export const loadTeamInfoSuccess = createAction(
    '[CANDIDATE TEAM INFO] Load Team Info Successfully',
    props<{ teamInfo: TeamInfo }>()
);
export const loadTeamInfoFailure = createAction(
    '[CANDIDATE TEAM INFO] Load Team Info Failure',
    props<{ error: unknown }>()
);
